import styled, { createGlobalStyle } from 'styled-components';

export const BiddingSummaryDrawerStyles = createGlobalStyle`
  :root {
    --bidding-summary-drawer-width: 72rem;
  }

  .modal.bidding-summary-drawer-modal {
    padding-left: 0;
    padding-right: 0;
    font-family: 'Roboto', sans-serif;
    pointer-events: none;
  }

  .modal.bidding-summary-drawer-modal.bidding-summary-drawer-modal--with-chat {
    z-index: 1049 !important;
  }

  .modal.bidding-summary-drawer-modal .modal-dialog.bidding-summary-drawer-dialog {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: auto;
    margin: 0;
    max-width: min(100vw, var(--bidding-summary-drawer-width));
    width: min(100vw, var(--bidding-summary-drawer-width));
    height: 100vh;
    max-height: 100vh;
    transform: translateX(100%);
    transition: transform 0.3s ease-out;
  }

  .modal.bidding-summary-drawer-modal--with-chat .modal-dialog.bidding-summary-drawer-dialog {
    left: auto;
    right: min(100vw, var(--bidding-chat-drawer-width, 46.2rem));
    width: min(
      var(--bidding-summary-drawer-width),
      calc(100vw - min(100vw, var(--bidding-chat-drawer-width, 46.2rem)))
    );
    max-width: min(
      var(--bidding-summary-drawer-width),
      calc(100vw - min(100vw, var(--bidding-chat-drawer-width, 46.2rem)))
    );
  }

  .modal.bidding-summary-drawer-modal.show .modal-dialog.bidding-summary-drawer-dialog {
    transform: translateX(0);
  }

  .modal.bidding-summary-drawer-modal .bidding-summary-drawer-content {
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    pointer-events: auto;
  }

  .modal.bidding-summary-drawer-modal--with-chat .bidding-summary-drawer-content {
    border-right: 1px solid #e8e8e8;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: none;
  }

  @media (max-width: 767.98px) {
    .modal.bidding-summary-drawer-modal--with-chat .modal-dialog.bidding-summary-drawer-dialog {
      width: 0;
      max-width: 0;
      overflow: hidden;
    }
  }

  .modal.bidding-summary-drawer-modal .bidding-summary-container {
    flex: 1 1 auto;
    min-height: 0;
  }

  .modal.bidding-summary-drawer-modal
    .card.summary-accordion-card.summary-accordion-card--danger-border {
    border-color: #c10007 !important;
  }

  .modal.bidding-summary-drawer-modal
    .card.summary-accordion-card.summary-accordion-card--warning-border {
    border-color: #ffc107 !important;
  }

  .modal.bidding-summary-drawer-modal
    .card.summary-accordion-card.summary-accordion-card--success-border {
    border-color: #28a745 !important;
  }

  .modal.bidding-summary-drawer-modal
    .card.summary-accordion-card.summary-accordion-card--exigencias-border {
    border: 1px solid #17a2b8 !important;
    border-radius: 8px;
  }
`;

export const Container = styled.div`
  &.bidding-summary-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    font-family: 'Roboto', sans-serif;
  }

  .modal-body.bidding-summary-drawer-body {
    min-height: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header.bidding-summary-modal-header {
    background: ${(props) => props.theme.$white};
    flex-shrink: 0;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #e8e8e8;

    .bidding-summary-header-inner {
      gap: 1rem;
    }

    .bidding-summary-header-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .bidding-summary-drawer-title {
      color: #1a2b3c;
      font-family: 'Roboto', sans-serif;
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 100%;
      letter-spacing: 0;
    }

    .bidding-summary-drawer-subtitle {
      color: #757575;
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      font-size: 1rem;
      line-height: 100%;
      letter-spacing: 0;
      margin-top: 0;
    }

    .bidding-summary-header-toolbar {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      gap: 1rem;
    }

    .bidding-summary-header-actions {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .btn.bidding-summary-header-action-btn {
      border: 1px solid transparent;
      border-radius: 7px;
      min-height: 40px;
      padding: 0.45rem 1.0125rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.5625rem;
      font-size: 0.9rem;
      font-weight: 600;
      line-height: 1.2;
      white-space: nowrap;
      background:
        linear-gradient(${(props) => props.theme.$white}, ${(props) => props.theme.$white}) padding-box,
        linear-gradient(90deg, #007bff, #009f79) border-box;
      transition: opacity 0.15s ease;
      box-shadow: none;

      .bidding-summary-header-action-btn-label {
        background: linear-gradient(90deg, #007bff, #009f79);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        -webkit-text-fill-color: transparent;
        line-height: 1.2;
      }

      .material-icons {
        flex-shrink: 0;
        font-size: 22px;
        width: 22px;
        height: 22px;
        line-height: 22px;
        margin-right: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, #007bff, #009f79);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        -webkit-text-fill-color: transparent;
      }

      .audio-loading-bars span:nth-child(1) {
        background: #007bff;
      }

      .audio-loading-bars span:nth-child(2) {
        background: #008b96;
      }

      .audio-loading-bars span:nth-child(3) {
        background: #009f79;
      }

      .bidding-summary-header-action-ia-wrap {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        line-height: 0;

        img {
          display: block;
          width: auto;
          height: 24px;
          max-height: 24px;
        }
      }

      &:hover,
      &:focus-visible {
        background:
          linear-gradient(#f3f8ff, #f3f8ff) padding-box,
          linear-gradient(90deg, #007bff, #009f79) border-box;
      }

      &:focus:not(:focus-visible) {
        background:
          linear-gradient(${(props) => props.theme.$white}, ${(props) => props.theme.$white}) padding-box,
          linear-gradient(90deg, #007bff, #009f79) border-box;
        box-shadow: none;
      }

      &.bidding-summary-header-action-btn--active {
        background:
          linear-gradient(${(props) => props.theme.$white}, ${(props) => props.theme.$white}) padding-box,
          linear-gradient(90deg, #007bff, #009f79) border-box;
        opacity: 0.72;
      }

      &:disabled {
        opacity: 0.65;
      }
    }

    .close.bidding-summary-header-close {
      margin: 0;
      color: #9e9e9e;
      opacity: 1;
      text-shadow: none;
      padding: 0.35rem 0.25rem;
      font-size: 1.5rem;
      line-height: 1;
      font-weight: 300;

      &:hover,
      &:focus {
        color: #757575;
        opacity: 1;
      }
    }
  }

  .summary-stat-card {
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  .summary-stat-label,
  .summary-field-label {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
  }

  .summary-field-value {
    font-size: 1rem;
  }

  .summary-programa-integridade-btn {
    padding: 0.125rem 0.5rem;
    font-size: 0.8125rem;
    line-height: 1.2;
  }

  .summary-stat-svg-head {
    font-size: 14px;
    line-height: 100%;
    gap: 0.5rem;
  }

  .summary-stat-svg-head .summary-stat-icon-img--svg {
    width: auto;
    height: 1.375em;
    flex-shrink: 0;
    display: block;
    object-fit: contain;
  }

  .summary-stat-icon {
    font-size: 28px;
    line-height: 1;
  }

  .summary-stat-icon-img {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    display: block;
    object-fit: contain;
  }

  .summary-stat-row {
    margin-bottom: 0.5rem;
  }

  .summary-stat-row .summary-stat-card .card-body {
    padding-left: calc(1.25rem * 0.9);
  }

  .badge-modo-disputa {
    color: #0d6efd;
    background: #e7f1ff;
    font-weight: 500;
  }

  .badge-sessao-dias {
    color: #6f42c1;
    background: #ede7f6;
    font-weight: 500;
  }

  button.accordion-section-toggle {
    background: #f4f5f7;
    padding: 0.875rem 1.5rem;

    &:hover {
      background: #ebedf0;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.$primary_green};
      outline-offset: 2px;
      position: relative;
      z-index: 1;
    }
  }

  .summary-accordion-title {
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 18px;
    line-height: 27px;
    letter-spacing: -0.44px;
  }

  .summary-accordion-head-icon {
    width: auto;
    height: 1.35em;
    flex-shrink: 0;
    margin-right: 0.5rem;
    display: block;
    object-fit: contain;
    align-self: center;
  }

  .summary-accordion-head-icon.material-icons {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: content-box;
    width: 27px;
    height: 27px;
    font-size: 22px;
    line-height: 1;
    object-fit: unset;
  }

  .summary-accordion-chevron {
    display: block;
    vertical-align: middle;
  }

  .summary-accordion-card.summary-accordion-card--exigencias-border .summary-accordion-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #17a2b8;
    color: ${(props) => props.theme.$white};
    border-radius: 4px;
    font-family: 'Roboto', sans-serif;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    padding: 0.25rem 0.5rem;
    margin-left: 0.5rem;
    white-space: nowrap;
  }

  .bidding-summary-exigencias-list {
    color: #333333;
  }

  .summary-accordion-card {
    overflow: hidden;
    border-radius: 6px;
  }

  .summary-accordion-body {
    background: ${(props) => props.theme.$white};
    font-size: 1rem;
    padding: 0.875rem 1.5rem;
  }

  .bidding-summary-garantias .bidding-summary-garantia-card:last-child {
    margin-bottom: 0;
  }

  .bidding-summary-garantia-card {
    border: 1px solid #dee2e6;
    background: #f4f5f7;
  }

  .bidding-summary-garantia-card--nao-exige {
    color: #333333;
  }

  .bidding-summary-garantia-card--exige {
    background: #d4edda;
    color: #155724;
  }

  .bidding-summary-questionamento-card {
    border: none;
    border-bottom: 2px solid #dee2e6;
    border-radius: 0;
    background: transparent;
    color: #333333;
    padding: 0 0 1rem 0 !important;
    margin-bottom: 1rem;
  }

  .bidding-summary-questionamento-card:last-child {
    margin-bottom: 0;
    padding-bottom: 0 !important;
  }

  .bidding-summary-questionamento-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #6c757d;
    color: #ffffff;
    border-radius: 4px;
    font-family: 'Roboto', sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    font-style: normal;
    line-height: 1;
    letter-spacing: 0;
    min-width: 6.25rem;
    min-height: 1.1rem;
    padding: 0 0.375rem;
    white-space: nowrap;
    margin-bottom: 0.5rem;
  }

  .bidding-summary-questionamento-title {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    font-weight: 700;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: #212529;
  }

  .bidding-summary-questionamento-trecho .btn {
    border-color: #c9ced6;
    background: transparent;
    color: #495057;
    min-height: 2.5rem;
    box-shadow: none !important;
  }

  .bidding-summary-questionamento-trecho .btn:hover,
  .bidding-summary-questionamento-trecho .btn:focus,
  .bidding-summary-questionamento-trecho .btn:active {
    background: transparent;
  }

  .bidding-summary-questionamento-trecho .btn[aria-expanded='true'] {
    border-bottom: 0 !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .bidding-summary-questionamento-trecho .btn .material-icons {
    font-size: 20px;
    line-height: 1;
  }

  .bidding-summary-questionamento-trecho-body {
    background: transparent;
    color: #6c757d;
    white-space: pre-wrap;
    font-family: 'Roboto', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    font-style: italic;
    line-height: 1.2;
    letter-spacing: -0.02em;
    border-top: 0 !important;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-top: -1px;
  }

  button.accordion-section-toggle.accordion-section-toggle--danger-soft {
    background: ${(props) => props.theme.$danger_light_bg};
    box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$danger_border_strong};

    &:hover {
      background: ${(props) => props.theme.$danger_light_bg_hover};
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$danger_border_strong};
    }

    &:focus:not(:focus-visible) {
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$danger_border_strong};
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.$danger_border_strong};
      outline-offset: 2px;
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$danger_border_strong};
      position: relative;
      z-index: 1;
    }
  }

  button.accordion-section-toggle.accordion-section-toggle--warning-soft {
    background: ${(props) => props.theme.$warning_light_bg};
    box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$warning};

    &:hover {
      background: ${(props) => props.theme.$warning_light_bg_hover};
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$warning};
    }

    &:focus:not(:focus-visible) {
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$warning};
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.$warning};
      outline-offset: 2px;
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$warning};
      position: relative;
      z-index: 1;
    }
  }

  button.accordion-section-toggle.accordion-section-toggle--success-soft {
    background: ${(props) => props.theme.$success_light_bg};
    box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$success};

    &:hover {
      background: ${(props) => props.theme.$success_light_bg_hover};
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$success};
    }

    &:focus:not(:focus-visible) {
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$success};
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.$success};
      outline-offset: 2px;
      box-shadow: inset 0 -1px 0 0 ${(props) => props.theme.$success};
      position: relative;
      z-index: 1;
    }
  }

  button.accordion-section-toggle.accordion-section-toggle--exigencias-soft {
    background: #d1ecf1;
    box-shadow: inset 0 -1px 0 0 #17a2b8;

    &:hover {
      background: #c5e5eb;
      box-shadow: inset 0 -1px 0 0 #17a2b8;
    }

    &:focus:not(:focus-visible) {
      box-shadow: inset 0 -1px 0 0 #17a2b8;
    }

    &:focus-visible {
      outline: 2px solid #17a2b8;
      outline-offset: 2px;
      box-shadow: inset 0 -1px 0 0 #17a2b8;
      position: relative;
      z-index: 1;
    }
  }

  .bidding-summary-footer {
    flex-shrink: 0;
    background: ${(props) => props.theme.$white};
    border-top: 1px solid ${(props) => props.theme.$gray300};
  }

  .bidding-summary-email-anchor {
    position: relative;
    display: inline-block;
    vertical-align: middle;
  }

  .bidding-summary-email-flyout {
    position: absolute;
    right: 0;
    bottom: 100%;
    margin-bottom: 0.375rem;
    width: min(22rem, calc(100vw - 2.5rem));
    z-index: 20;
  }

  .btn-feedback {
    font-size: 0.8rem;
    text-decoration: underline;
  }

  .bidding-summary {
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-color: ${(props) => props.theme.$gray600} ${(props) => props.theme.$white};
    scrollbar-width: thin;
  }

  ul {
    list-style: disc;
  }
`;

export const biddingSummaryShareEmailStyles = `
  body {
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    color: #212529;
  }
  .email-summary-banner {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #000;
  }
  .bidding-summary-email-root ul {
    list-style: disc;
  }
  .summary-stat-card {
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }
  .summary-stat-label,
  .summary-field-label {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
  }
  .summary-field-value {
    font-size: 1rem;
  }
  .summary-stat-svg-head {
    font-size: 14px;
    line-height: 100%;
    gap: 0.5rem;
    margin-bottom: 0.35rem;
  }
  .summary-stat-row {
    margin-bottom: 0.5rem;
  }
  .summary-stat-row .summary-stat-card .card-body {
    padding-left: calc(1.25rem * 0.9);
  }
  .badge-modo-disputa {
    color: #0d6efd;
    background: #e7f1ff;
    font-weight: 500;
  }
  .badge-sessao-dias {
    color: #6f42c1;
    background: #ede7f6;
    font-weight: 500;
  }
  button.accordion-section-toggle {
    background: #f4f5f7;
    padding: 0.875rem 1.5rem;
  }
  .summary-accordion-title {
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    letter-spacing: -0.44px;
  }
  .summary-accordion-card {
    overflow: hidden;
    border-radius: 6px;
  }
  .summary-accordion-card.summary-accordion-card--danger-border {
    border-color: #c10007;
  }
  .summary-accordion-card.summary-accordion-card--warning-border {
    border-color: #ffc107;
  }
  .summary-accordion-card.summary-accordion-card--success-border {
    border-color: #28a745;
  }
  .summary-accordion-card.summary-accordion-card--exigencias-border {
    border: 1px solid #17a2b8;
    border-radius: 8px;
  }
  .summary-accordion-card.summary-accordion-card--exigencias-border .summary-accordion-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #17a2b8;
    color: #ffffff;
    border-radius: 4px;
    font-family: 'Roboto', sans-serif;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    padding: 0.25rem 0.5rem;
    margin-left: 0.5rem;
    white-space: nowrap;
  }
  .bidding-summary-exigencias-list {
    color: #333333;
  }
  button.accordion-section-toggle.accordion-section-toggle--exigencias-soft {
    background: #d1ecf1;
    box-shadow: inset 0 -1px 0 0 #17a2b8;
  }
  .summary-accordion-body {
    background: #ffffff;
    font-size: 1rem;
    padding: 0.875rem 1.5rem;
  }
  .bidding-summary-garantias .bidding-summary-garantia-card:last-child {
    margin-bottom: 0;
  }
  .bidding-summary-garantia-card {
    border: 1px solid #dee2e6;
    background: #f4f5f7;
  }
  .bidding-summary-garantia-card--nao-exige {
    color: #333333;
  }
  .bidding-summary-garantia-card--exige {
    background: #d4edda;
    color: #155724;
  }
  button.accordion-section-toggle.accordion-section-toggle--danger-soft {
    background: #f8d7da;
    box-shadow: inset 0 -1px 0 0 #c10007;
  }
  button.accordion-section-toggle.accordion-section-toggle--warning-soft {
    background: #fff3cd;
    box-shadow: inset 0 -1px 0 0 #ffc107;
  }
  button.accordion-section-toggle.accordion-section-toggle--success-soft {
    background: #d4edda;
    box-shadow: inset 0 -1px 0 0 #28a745;
  }
  img {
    max-width: 100%;
    height: auto;
  }
`;
